(() => {
  const chat = document.querySelector('shopify-chat');
  const footer = document.querySelector('.vn-footer');
  if (!chat) return;
  let footerVisible = false;
  const update = () => {
    if (chat.hasAttribute('open')) return;
    const dialogOpen = [...document.querySelectorAll('dialog[open]')].some(dialog => !dialog.contains(chat));
    if (footerVisible && chat.matches(':focus-within') && !dialogOpen) {
      footer.querySelector('.vn-contact-email')?.focus({ preventScroll: true });
    }
    const editingHoliday = Boolean(document.activeElement?.closest('venro-holiday-customizer form'));
    chat.toggleAttribute('data-vn-launcher-hidden', footerVisible || dialogOpen || editingHoliday);
  };
  if (footer) new IntersectionObserver(([entry]) => {
    footerVisible = entry.isIntersecting;
    update();
  }).observe(footer);
  document.addEventListener('toggle', update, true);
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => queueMicrotask(update));
  new MutationObserver(update).observe(chat, { attributes: true, attributeFilter: ['open'] });
  update();
})();
